module.exports = __webpack_public_path__ + "img/kg-logo.d501206c.png";